import React, { useState } from "react";
import { CONTACT_CONFIG } from "../config/contact";

export default function Faq() {
  // Utilisation des variables de configuration centralisées
  const { phoneNumber: PHONE_NUMBER, whatsappUrl: WHATSAPP_URL } = CONTACT_CONFIG;

const faqData = [
  {
    question: "El precio es mensual? Me cobrarán de nuevo?",
    answer:
      "No, es un pago único. No cobramos tarifas mensuales y no renovamos automáticamente su suscripción. Usted paga una sola vez y obtiene acceso por el período elegido (por ejemplo, un año, 15 meses o 24 meses).",
  },
  {
    question: "Cómo recibo mi suscripción?",
    answer: (
      <>
        Después del pago, recibirá sus credenciales por correo electrónico en 10 a 30
        minutos. Verifique su carpeta de spam. Si no recibe nada,
        contáctenos por WhatsApp:{" "}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#090979] hover:text-[#090979] font-semibold"
          style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M20.52 3.48A11.77 11.77 0 0 0 12.04 0C5.39 0 .02 5.37.02 12.02c0 2.12.55 4.18 1.59 6.01L0 24l6.14-1.61a11.93 11.93 0 0 0 5.9 1.51h.01c6.64 0 12.02-5.38 12.02-12.02 0-3.21-1.25-6.22-3.55-8.4zM12.05 21.5c-1.88 0-3.71-.5-5.3-1.44l-.38-.23-3.64.96.97-3.54-.25-.37a9.48 9.48 0 0 1-1.46-5.1c0-5.24 4.27-9.51 9.52-9.51 2.54 0 4.92.99 6.72 2.78a9.43 9.43 0 0 1 2.78 6.72c0 5.25-4.27 9.53-9.52 9.53zm5.26-7.12c-.29-.15-1.72-.85-1.99-.95-.27-.1-.46-.15-.65.15-.19.29-.75.95-.92 1.14-.17.19-.34.21-.63.06-.29-.15-1.23-.45-2.35-1.44-.87-.78-1.46-1.74-1.63-2.03-.17-.29-.02-.45.13-.6.14-.14.29-.34.43-.51.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.15-.65-1.57-.89-2.15-.23-.56-.47-.49-.65-.5h-.56c-.19 0-.51.07-.77.36-.26.29-1.01.98-1.01 2.39s1.03 2.77 1.17 2.96c.14.19 2.02 3.09 4.89 4.33.68.29 1.21.46 1.62.59.68.21 1.29.18 1.77.11.54-.08 1.72-.7 1.96-1.38.24-.68.24-1.26.17-1.38-.07-.12-.26-.19-.54-.33z" />
          </svg>
          {PHONE_NUMBER}
        </a>
      </>
    ),
  },
  {
    question: "Cómo suscribirse a TVMARCA?",
    answer:
      "Para suscribirse a TVMARCA, visite nuestro sitio web y elija una suscripción adaptada a sus necesidades. Será redirigido a otro sitio para finalizar su pago. Una vez terminado, recibirá sus códigos con instrucciones detalladas, paso a paso, para instalarlo en sus dispositivos.",
  },
  {
    question:
      "Puedo usar TVMARCA en varios dispositivos simultáneamente?",
    answer:
      "Sí, si tiene una suscripción Gold, puede ver en varios dispositivos simultáneamente.",
  },
  {
    question:
      "Por qué soy redirigido a otro sitio para finalizar mi compra?",
    answer:
      "Para transacciones seguras, usted es redirigido al sitio de nuestro socio de pago de confianza. Una vez finalizada su compra, recibirá su código de activación TVMARCA por correo electrónico. No dude en contactarnos para cualquier pregunta.",
  },
  {
    question: "Necesito una antena satelital para usar TVMARCA?",
    answer:
      "No, usted se conecta a los servidores de TVMARCA a través de Internet, y no necesita una parabólica o equipo satelital.",
  },
  {
    question: "Puedo pagar mi suscripción con PayPal?",
    answer: (
      <>
        Sí, puede pagar su suscripción con PayPal, Crypto u otros
        métodos de pago específicos. Para estas opciones de pago,
        envíenos un mensaje por WhatsApp:{" "}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#090979] hover:text-[#090979] font-semibold"
          style={{ display: "inline-flex", alignItems: "center", gap: "4px" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M20.52 3.48A11.77 11.77 0 0 0 12.04 0C5.39 0 .02 5.37.02 12.02c0 2.12.55 4.18 1.59 6.01L0 24l6.14-1.61a11.93 11.93 0 0 0 5.9 1.51h.01c6.64 0 12.02-5.38 12.02-12.02 0-3.21-1.25-6.22-3.55-8.4zM12.05 21.5c-1.88 0-3.71-.5-5.3-1.44l-.38-.23-3.64.96.97-3.54-.25-.37a9.48 9.48 0 0 1-1.46-5.1c0-5.24 4.27-9.51 9.52-9.51 2.54 0 4.92.99 6.72 2.78a9.43 9.43 0 0 1 2.78 6.72c0 5.25-4.27 9.53-9.52 9.53zm5.26-7.12c-.29-.15-1.72-.85-1.99-.95-.27-.1-.46-.15-.65.15-.19.29-.75.95-.92 1.14-.17.19-.34.21-.63.06-.29-.15-1.23-.45-2.35-1.44-.87-.78-1.46-1.74-1.63-2.03-.17-.29-.02-.45.13-.6.14-.14.29-.34.43-.51.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.15-.65-1.57-.89-2.15-.23-.56-.47-.49-.65-.5h-.56c-.19 0-.51.07-.77.36-.26.29-1.01.98-1.01 2.39s1.03 2.77 1.17 2.96c.14.19 2.02 3.09 4.89 4.33.68.29 1.21.46 1.62.59.68.21 1.29.18 1.77.11.54-.08 1.72-.7 1.96-1.38.24-.68.24-1.26.17-1.38-.07-.12-.26-.19-.54-.33z" />
          </svg>
          {PHONE_NUMBER}
        </a>
      </>
    ),
  },
  {
    question: "Este servicio TVMARCA funciona en mi país?",
    answer:
      "TVMARCA funciona en todo el mundo, donde sea que viva o se encuentre. Mientras tenga una conexión a Internet estable, puede ver miles de canales de TV.",
  },
];

  const [openIndex, setOpenIndex] = useState(0);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-slate-50">
      <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto pb-8 sm:pb-10 pt-5">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl mx-auto font-black mb-3 sm:mb-4 max-w-3xl leading-snug text-center">
            Preguntas{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#04003b] via-[#090979] to-[#00d4ff]">
              Frecuentes
            </span>
          </h2>
          <p className="text-base sm:text-lg text-slate-600 max-w-2xl mx-auto font-medium">
            Encuentra respuestas a preguntas comunes sobre TVMARCA
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 max-w-full mx-auto">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-md p-4 sm:p-6 cursor-pointer transition-all duration-300 hover:shadow-lg"
              onClick={() => toggleFaq(index)}
            >
              <div className="flex items-center justify-between">
                <h3 className="font-bold text-slate-900 text-sm sm:text-base lg:text-lg pr-3 sm:pr-4 leading-tight">
                  {faq.question}
                </h3>
                <div className="flex-shrink-0">
                  {openIndex === index ? (
                    <span className="w-5 h-5 sm:w-6 sm:h-6 text-[#090979] text-xl sm:text-2xl font-bold">
                      −
                    </span>
                  ) : (
                    <span className="w-5 h-5 sm:w-6 sm:h-6 text-[#090979] text-xl sm:text-2xl font-bold">
                      +
                    </span>
                  )}
                </div>
              </div>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index
                    ? "max-h-96 opacity-100"
                    : "max-h-0 opacity-0"
                }`}
              >
                <div className="text-slate-700 mt-3 sm:mt-4 pt-3 sm:pt-4 border-t border-slate-200 leading-relaxed text-sm sm:text-base">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
